module.exports = __webpack_public_path__ + "img/banner_left.3d66db29.png";